import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PaymentTask, PurchaseOrderContractTask } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 1000. 支払タスク詳細
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};
const paymentTask = (props: Props): Promise<PaymentTask> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.id}`);
};

export const usePaymentTask = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => paymentTask(props),
  });
};

export const usePaymentTaskInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.purchase_order_id, 'payment_tasks', props.id];
};
